import { FormikErrors } from 'formik'

import AgentService from '../../../core/services/agent.service'
import {
  biggerThanZero,
  required,
  validEmail,
  validPhoneLength,
  validPhoneNumber,
} from '../../_utils/formValidators'
import { ContactDataInfoValues } from './ContactData.view'

const validateCompanyName = (locationScope: string) => {
  return required.default(locationScope.trim())
}

const validateFirstName = (firstName: string) => {
  return required.default(firstName.trim())
}

const validateLastName = (lastName: string) => {
  return required.default(lastName.trim())
}

const validateEmail = (email: string) => {
  return required.default(email.trim()) || validEmail.default(email.trim())
}

const validatePhoneNumber = (phone: string) => {
  return phone
    ? validPhoneLength.default(phone) || validPhoneNumber.default(phone)
    : undefined
}

const validatePrivacyPolicy = (checkboxChecked: boolean) => {
  return biggerThanZero('validator.termsSelected')(Number(checkboxChecked))
}

export const validateFieldForm = (formValueFields: ContactDataInfoValues) => {
  const errors: FormikErrors<ContactDataInfoValues> = {}

  if (validateCompanyName(formValueFields.company)) {
    errors.company = validateCompanyName(formValueFields.company)
  }

  if (validateFirstName(formValueFields.firstName)) {
    errors.firstName = validateFirstName(formValueFields.firstName)
  }

  if (validateLastName(formValueFields.lastName)) {
    errors.lastName = validateLastName(formValueFields.lastName)
  }

  if (validateEmail(formValueFields.email)) {
    errors.email = validateEmail(formValueFields.email)
  }

  if (validatePhoneNumber(formValueFields.phone)) {
    errors.phone = validatePhoneNumber(formValueFields.phone)
  }

  if (
    !AgentService.isAgentOrBroker() &&
    validatePrivacyPolicy(formValueFields.acceptedPrivacyPolicy)
  ) {
    errors.acceptedPrivacyPolicy = validatePrivacyPolicy(
      formValueFields.acceptedPrivacyPolicy,
    )
  }

  return errors
}
